// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"style_tabsWrapper__QOn8W","titleWrapper":"style_titleWrapper__vqg7k","warningIcon":"style_warningIcon__5e--k","circleIcon":"style_circleIcon__kpXFJ"};